(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('IndividualMeterDeleteController',IndividualMeterDeleteController);

    IndividualMeterDeleteController.$inject = ['$uibModalInstance', 'entity', 'IndividualMeter'];

    function IndividualMeterDeleteController($uibModalInstance, entity, IndividualMeter) {
        var vm = this;
        vm.individualMeter = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            IndividualMeter.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
